import React from "react"
import { AppBasicTable, NoDataFound } from "@components"
import { useInfoBlockData } from "Pages/BusinessLogistics/Analytics/Page/@hooks"
import { Skeleton } from "@mui/material"
import { labelColumn, searchesColumn } from "Pages/BusinessLogistics/Analytics/Page/@components/Table/@columns"


export default function EuropcarTable({ label, requestType }) {

	const { res, isLoading } = useInfoBlockData(requestType, true)

	if (isLoading) return <Skeleton variant="rectangular" height={400}/>

	if (!res?.length) return <NoDataFound/>

	return <AppBasicTable
		toolbarProps={{ actions: false }}
		titleProps={{ actions: false }}
		sx={{ height: 313 }}
		data={res}
		setHeaderCellProps={(_, idx) => ({
			sx: {
				backgroundColor: 'primary.main',
				textAlign: !idx && "left !important"
			}
		})}
		headers={[[
			{ label: label },
			{ label: 'Searches' },
		]]}
		columns={[labelColumn(label), searchesColumn()]}/>

}